import React, { Component } from 'react'
import axios from 'axios'
import { Alert, Container, Row, Button, Card, CardHeader} from "shards-react";
import { Form } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';


const parentUrl = process.env.REACT_APP_RE_URL;


class EditEntity extends Component {

  constructor (props, context) {
    super(props, context)
    this.props = props;
    this.state = {
      loading: true,
      goToEntities: false,
      apiErr: null,
      formValidated: true,
    }
    this.data = {
      enabled: true,
    }
  }

  handleChange = (field, event) => {

    if (field === 'enabled') {
      this.setState({
        [field]: event.target.value === 'true'
      })
    } else {
      this.setState({
        [field]: event.target.value
      })
    }
  }


  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    var id = this.props.id;
    const url = parentUrl + "/smre/1.0/entities/"+id;
    const self = this;

    if (form.checkValidity() === false) {
      this.setState({
        formValidated: false,
      })
      return;
    }

    this.setState({
      loading: true
    })
    const token = auth.getAccessToken()

    const entity = {
        "name" : this.state.name,
        "email" : this.state.email,
        "address" : this.state.address,
        "floor" : this.state.floor,
        "dpto" : this.state.dpto,
        "business_id" : this.state.business_id,
        "phone_number" : this.state.phone_number,
        "enabled" : this.state.enabled
    }

    axios.put(
      url,
      entity,
      {headers: {"Authorization" : "Bearer "+token}
    })
    .then(function (response) {
      self.setState({
         loading: false,
         goToEntities: true
      })
    }).catch(function (error) {

      self.setState({
         apiErr: error.response ? (error.response.data.message ? error.response.data : error.response.data.error) : error,
         loading: false
      })
    });

  }

  componentDidMount () {
    this._getEntity()
  }

  _getEntity() {
    var id = this.props.id;
    const token = auth.getAccessToken()
    const url = parentUrl + "/smre/1.0/entity_declarations/"+id;
    const self = this;

    axios.get(
      url,
      {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization" : "Bearer "+token
        }
      }
    ).then(function (response) {

      var entity = response.data.entity_declarations;
      // TODO Hardcode del carrito...
      const url = "http://carrito.singularmentor.com.ar/smre/entity-describe/"+entity.name;

      axios.get(
        url,
        {
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              "Authorization" : "Bearer "+token
          }
        }
      ).then(function (response) {

          var columns =  JSON.parse(response.data.replace('"'+entity.name+'":', '')).columns;

          self.setState({
            loading: false,
            name : entity.name,
            version : entity.version,
            columns : columns,
            definition : JSON.parse(entity.definition)[entity.name]
          })

      }).catch(function (error) {
          self.setState({
              entities: []
          })
      });



    }).catch(function (error) {

      self.setState({
        loading: false,
        apiErr: error.response ? (error.response.data.message ? error.response.data : error.response.data.error) : error
      })

    });
  }

  goBack = () => {
    history.goBack();
  }

  render = () => {
    const columns = this.state.columns

    // if(auth.isAuthenticated()){

        if (this.state.loading) {
          return (
            <div>
              <Container fluid>
                <br/>
                <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
                </div>
              </Container>
            </div>
          )
        }

        if (this.state.goToEntities){
            return <Redirect to='/entities' />
        }

        let error
        if (this.state.apiErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiErr.message}</Alert></Container>
        }

        return (
          <div>

            {error}

            <Container fluid>

              <Row noGutters className="page-header py-4">
                <PageTitle title={this.context.t('Entities')} subtitle={this.context.t('Edit')} className="text-sm-left mb-3" />
              </Row>

              <Card small style={{ marginBottom: '20px'}}>
                <CardHeader className="border-bottom">
                  <h5 className="m-0">
                      <i className="material-icons blue-text md-24" style={{float: "left"}}>contacts</i>
                      <span style={{float: "left", marginTop: "2px", marginLeft: "2px"}}>  {this.state.name} ({this.state.version})</span>
                  </h5>

                  <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px"}}  onClick={e => {this.goBack()}}>arrow_back</i>

                </CardHeader>
                <Form validate="true" onSubmit={e => this.handleSubmit(e)} style={{ padding: "10px"}}>
                     <table id="entitiesTable" className="mdl-data-table" width="100%">
                        <thead>
                            <tr>
                                <th>NAME</th>
                                <th>JAVA TYPE</th>
                                <th>SQL TYPE</th>
                                <th>SIZE</th>
                                <th>NULL</th>
                                <th>HIDDEN</th>
                            </tr>
                        </thead>
                        <tbody>
                            { columns && columns.length > 0 ? columns && columns.map(column => {
                                  return (
                                    <tr key={column.id} style={{ margin: '10px' }}>
                                        <td>{column.columnname} {column.ispk ?   <Button size="sm" theme="success" className="mb-2 mr-1" style={{padding: "2px", fontSize: "8px", marginTop: "6px"}}>PK</Button> : null}</td>
                                        <td>{column.jdatatype}</td>
                                        <td>{column.typename}</td>
                                        <td>{column.columnsize}</td>
                                        <td>{column.isnullable}</td>
                                        <td></td>
                                    </tr>
                                  )
                                }) : <tr><td><div className="alert alert-danger"> No se pudieron cargar los datos</div></td></tr>
                            }
                        </tbody>
                     </table>

                    <hr/>

                    <Button theme="primary" outline className="mb-2 mr-1" type='submit'>{this.context.t('Save')}</Button>
                    &nbsp;
                    <Button theme="secondary" outline className="mb-2 mr-1" onClick={this.goBack}>{this.context.t('Cancel')}</Button>
                  </Form>
              </Card>

            </Container>
          </div>
        )
    // }else{
    //     return <Redirect to='/' />
    // }
  }
}

EditEntity.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(EditEntity)
